import React from 'react'
import { toJS } from 'mobx'

import { inject, observer } from 'mobx-react'

import './index.scss'

import Icon from '@mdi/react'
import { mdiClose } from '@mdi/js'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

/**
 * CustomTabs component for rendering sub tabs inside a page
 * @prop {any} routerData holds router data: history, location and match
 */
@inject('internal')
@observer
export default class CustomTabs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            value: Number(this.props.routerData.match.params.tabIndex)
                ? Number(this.props.routerData.match.params.tabIndex)
                : 0,
            tabName: this.props.routerData.match.params.tabName,
            tabs: []
        }
    }

    componentWillReceiveProps() {
        /**
         * @rs
         * 03.09.2019
         * commented out => This code snippet is (from my understanding) absolutely pointless,
         * this reload only removes and prevents errors, that can be prevented by more sophisticated means.
         * Uncomment it only if you have a good reason for that (i couldnt find one), thanks.
         */
        // if (toJS(this.props.internal.notifiId) !== null) {
        // window.location.reload()
        // }
    }

    componentDidMount() {
        this.setState({ tabs: this.props.tabsConfig })
        if (this.props.module === '/clients') {
            let tabs = this.props.tabsConfig
            for (let i = 0; i < tabs.length; i++) {
                let url = tabs[i].url.split('/')
                if (url[url.length - 1] === this.props.routerData.match.params.tabName) {
                    this.setState({ value: i })
                    break
                }
            }
        } else if (this.props.module === '/privileges') {
            let tabs = this.props.tabsConfig
            for (let i = 0; i < tabs.length; i++) {
                let url = tabs[i].url.split('/')
                if (url[url.length - 1] === this.props.routerData.match.params.tabName) {
                    this.setState({ value: i })
                    break
                }
            }
        } else if (this.props.module === '/settings') {
            let tabs = this.props.tabsConfig
            for (let i = 0; i < tabs.length; i++) {
                let url = tabs[i].url.split('/')
                if (url[url.length - 1] === this.props.routerData.match.params.tabName) {
                    this.setState({ value: i })
                    break
                }
            }
        } else if (this.props.module === '/shops') {
            let tabs = this.props.tabsConfig
            for (let i = 0; i < tabs.length; i++) {
                let url = tabs[i].url.split('/')
                if (url[url.length - 1] === this.props.routerData.match.params.tabName) {
                    this.setState({ value: i })
                    break
                }
            }
        }else if (this.props.module === '/issue-cards') {
            let tabs = this.props.tabsConfig
            for (let i = 0; i < tabs.length; i++) {
                let url = tabs[i].url.split('/')
                if (url[url.length - 1] === this.props.routerData.match.params.tab) {
                    this.setState({ value: i })
                    break
                }
            }
        }
    }

    handleChange = (event, value) => {
        this.setState({ value: value }, () => {
            if (this.props.module === '/clients') {
                let idClient = this.props.routerData.match.params.idClient

                let tempHistory = this.props.routerData.history

                let newActiveTabUrlArr = this.state.tabs[this.state.value].url.split('/')
                let newActiveTab = newActiveTabUrlArr[newActiveTabUrlArr.length - 1]

                let newUrl = `/clients/${idClient}/${newActiveTab}`
                this.props.internal.setRoute(tempHistory, newUrl)
                this.props.internal.pushRoute(newUrl)
            } else if (this.props.module === '/privileges') {
                let tempHistory = this.props.routerData.history

                let newActiveTabUrlArr = this.state.tabs[this.state.value].url.split('/')
                let newActiveTab = newActiveTabUrlArr[newActiveTabUrlArr.length - 1]

                let newUrl = `/privileges/${newActiveTab}`
                this.props.internal.setRoute(tempHistory, newUrl)
                this.props.internal.pushRoute(newUrl)
            } else if (this.props.module === '/settings') {
                let tempHistory = this.props.routerData.history

                let newActiveTabUrlArr = this.state.tabs[this.state.value].url.split('/')
                let newActiveTab = newActiveTabUrlArr[newActiveTabUrlArr.length - 1]

                let newUrl = `/settings/${newActiveTab}`
                this.props.internal.setRoute(tempHistory, newUrl)
                this.props.internal.pushRoute(newUrl)
            } else if (this.props.module === '/shops') {
                let idShop = this.props.routerData.match.params.id

                let tempHistory = this.props.routerData.history

                let newActiveTabUrlArr = this.state.tabs[this.state.value].url.split('/')
                let newActiveTab = newActiveTabUrlArr[newActiveTabUrlArr.length - 1]

                let newUrl = `/shops/${idShop}/${newActiveTab}`
                this.props.internal.setRoute(tempHistory, newUrl)
                this.props.internal.pushRoute(newUrl)
            } else if (this.props.module === '/issue-cards') {
                let idCard = this.props.routerData.match.params.id

                let tempHistory = this.props.routerData.history

                let newActiveTabUrlArr = this.state.tabs[this.state.value].url.split('/')
                let newActiveTab = newActiveTabUrlArr[newActiveTabUrlArr.length - 1]

                let newUrl = `/issue-cards/${idCard}/${newActiveTab}`
                this.props.internal.setRoute(tempHistory, newUrl)
                this.props.internal.pushRoute(newUrl)
            } else {
                let pathWithNewTabIndex =
                    this.props.routerData.location.pathname.slice(0, -1) + this.state.value
                let tempHistory = this.props.routerData.history
                tempHistory.location.pathname = pathWithNewTabIndex
                this.props.internal.setRoute(tempHistory, pathWithNewTabIndex)
                this.props.internal.pushRoute(pathWithNewTabIndex)
            }
        })
    }

    handleGoBack = () => {
        if (this.props.goBack) {
            this.props.internal.setRoute(this.props.routerData.history, this.props.goBack)
            this.props.internal.pushRoute(this.props.goBack)
        } else if (toJS(this.props.internal.lastVisitedPage) !== null) {
            this.props.internal.setRoute(
                this.props.routerData.history,
                toJS(this.props.internal.lastVisitedPage)
            )
            this.props.internal.pushRoute(toJS(this.props.internal.lastVisitedPage))
        } else {
            this.props.internal.setRoute(this.props.routerData.history, this.props.module)
            this.props.internal.pushRoute(this.props.module)
        }
    }

    render() {
        let tabs = this.props.children.map((data) => {
            return data
        })

        return (
            <div>
                <div className={'flex space-between'}>
                    <div className={'subtitle'}>{this.props.title}</div>
                    {this.props.goBackNone ? null : (
                        <div className={'close'} onClick={this.handleGoBack}>
                            <Icon path={mdiClose} size={1} />
                        </div>
                    )}
                </div>
                <Tabs
                    scrollable
                    scrollButtons='on'
                    value={this.state.value}
                    onChange={this.handleChange}
                    className={'list-tabs'}
                    classes={{
                        indicator: 'orangeIndicator',
                        scrollButtons: 'scrollButtons'
                    }}
                >
                    {this.props.tabsConfig.map((tab) => {
                        return <Tab key={tab.label} value={tab.value} label={tab.label} className={'tab'} />
                    })}
                </Tabs>

                {tabs.map((data, index) => {
                    if (this.state.value === index) {
                        return data
                    } else {
                        return null
                    }
                })}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/customTabs/index.js